export default __webpack_public_path__ + "static/media/hamyar-popup.ae7e1caa.jpg";